import { render, staticRenderFns } from "./Magnet.vue?vue&type=template&id=1ab2290c&scoped=true&"
import script from "./Magnet.vue?vue&type=script&lang=js&"
export * from "./Magnet.vue?vue&type=script&lang=js&"
import style0 from "./Magnet.vue?vue&type=style&index=0&id=1ab2290c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2290c",
  null
  
)

export default component.exports